export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '18-35',
              value: 1,
              selected: false
            },
            {
              label: '35-54',
              value: 2,
              selected: false
            },
            {
              label: '55+',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Income',
          code: 'income',
          multi: true,
          options: [
            {
              label: '$20k-$69k',
              value: 1,
              selected: false
            },
            {
              label: '$70k-$124k',
              value: 2,
              selected: false
            },
            {
              label: '$125k+',
              value: 3,
              selected: false
            },
            {
              label: 'Prefer Not to Answer',
              value: 4,
              selected: false
            }
          ]
        },
        {
          label: 'Investable Assets',
          code: 'assets',
          multi: true,
          options: [
            {
              label: 'Under $25,000',
              value: 1,
              selected: false
            },
            {
              label: '$25k-$99k',
              value: 2,
              selected: false
            },
            {
              label: '$100k-$249k',
              value: 3,
              selected: false
            },
            {
              label: '$250k+',
              value: 4,
              selected: false
            },
            {
              label: 'Prefer Not to Answer',
              value: 5,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Ethnicity',
          code: 'ethnicity',
          multi: true,
          options: [
            {
              label: 'White',
              value: 1,
              selected: false
            },
            {
              label: 'Black',
              value: 2,
              selected: false
            },
            {
              label: 'Latino',
              value: 3,
              selected: false
            },
            {
              label: 'Asian',
              value: 4,
              selected: false
            },
            {
              label: 'American Indian',
              value: 5,
              selected: false
            },
            {
              label: 'Middle Eastern/North African',
              value: 6,
              selected: false
            },
            {
              label: 'Hawaiian/Pacific Islander',
              value: 7,
              selected: false
            },
            {
              label: 'Other',
              value: 8,
              selected: false
            }
          ]
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/config/components/scorecard/ScorecardView/ScorecardFilter/index.js